import '../globals';

;(function ($) {
    'use strict';

    var pluginName = 'punchOut';

    function Plugin(element) {
        this.element = $(element);
        this._name = pluginName;
        this.requestArguments = $.fn.requestArguments();
        this.init();

        return this;
    }

    $.extend(Plugin.prototype, {
        /**
         * Init
         */
        init: function () {
            this.element.on('click touchend', '.punch-out-submit', function () {
                var that = this;
                $(this).attr('disabled', 'disabled');
                var cleanupUrl = $(this).data('punchout-cleanup');
                $.ajax(cleanupUrl).done(function () {
                    $(that).closest('form').submit();
                });

                return false;
            });
        }
    });

    /**
     * Plugin wrapper
     */
    $.fn[pluginName] = function () {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new Plugin(this));
            }
        });
    };
})(jQuery);
